import { useState } from 'react';
import {
	Box,
	CircularProgress,
	FormControl,
	MenuItem,
	Select,
	Typography,
} from '@mui/material';

const SingleSelect = ({
	value = '',
	options = [],
	disabled = false,
	loading = false,
	size = 'small',
	onChange,
	errorMessage,
	placeholder = '',
}) => {
	const [localError, setLocalError] = useState(null);

	const handleChange = async (event) => {
		const nextValue = event.target.value;

		if (nextValue === value) return;

		setLocalError(null);

		try {
			await onChange?.(nextValue);
		} catch (error) {
			setLocalError(error?.message || 'Unable to update. Please try again.');
		}
	};

	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
			<FormControl fullWidth size={size} disabled={disabled || loading}>
				<Select
					data-testid='single-select'
					value={value}
					onChange={handleChange}
					displayEmpty
					renderValue={(selected) =>
						selected ? (
							selected
						) : (
							<Typography
								component='span'
								sx={{ color: 'text.disabled', fontSize: 'inherit' }}
							>
								{placeholder}
							</Typography>
						)
					}
					sx={{
						fontSize: 12,
						minHeight: 32,
						backgroundColor: 'background.paper',
					}}
					endAdornment={
						loading ? (
							<CircularProgress size={16} color='inherit' sx={{ mr: 3 }} />
						) : null
					}
				>
					{options.map((option) => {
						const item =
							typeof option === 'string'
								? { label: option, value: option }
								: option;

						return (
							<MenuItem key={item.value} value={item.value}>
								{item.label}
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>

			{(errorMessage || localError) && (
				<Typography fontSize={11} color='error.main'>
					{errorMessage || localError}
				</Typography>
			)}
		</Box>
	);
};

export default SingleSelect;
